class GmwSubmit {
    constructor($parse, $timeout) {
        this.$parse = $parse;
        this.$timeout = $timeout;
        this.restrict = 'A';
    }
    static factory() {
        const directive = ($parse, $timeout) => new GmwSubmit($parse, $timeout);
        directive.$inject = ['$parse', '$timeout'];
        return directive;
    }
    compile(_element, attrs) {
        const fn = this.$parse(attrs.gmwSubmit, undefined, true);
        return (scope, element) => {
            element.on('submit', $event => {
                const btnEl = element.find('button[type=submit]');
                btnEl.addClass('loading-button');
                btnEl.prop('disabled', true);
                this.$timeout(() => {
                    const result = fn(scope, { $event });
                    if (result && angular.isFunction(result.finally)) {
                        result.finally(() => {
                            btnEl.removeClass('loading-button');
                            btnEl.prop('disabled', false);
                        });
                    }
                    else {
                        btnEl.removeClass('loading-button');
                        btnEl.prop('disabled', false);
                    }
                });
            });
        };
    }
}
export default angular
    .module('gm.wealth.common')
    .directive('gmwSubmit', GmwSubmit.factory());



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/common/directives/submit/submit.ts